import Tabs from "../Tabs";
import ResultsSubmissionForm from "../ResultsSubmissionForm";

/**
 * Shared page shell for displaying a single eval: tab navigation, title line,
 * the active tab's content, and the sticky collapsible results submission form
 * pinned to the bottom. Extracted from the legacy eval view so the cloud eval
 * view presents identically — callers supply their own tabs, adapted data,
 * and submission metadata. `scoringForm` replaces the legacy Firestore form
 * in the same sticky panel (cloud evals pass their report-backed form).
 */
export default function EvalDisplayShell({
    tabs,
    currentTab,
    setCurrentTab,
    title,
    showResultsForm = true,
    submissionMeta,
    scoringForm,
    onSubmitSuccess = () => {
        alert('Results submitted successfully!');
    },
    children
}) {
    return (
        <div className={"py-10"}>
            <Tabs tabs={tabs} currentTab={currentTab} setCurrentTab={setCurrentTab} />
            <h1 className={"py-2"}>{title}</h1>

            {/* Charts and data - full width */}
            <div className="mb-6">
                {children}
            </div>

            {/* Sticky scoring form at bottom */}
            {showResultsForm && (
                <div className="sticky bottom-0 bg-gray-100 border-t border-gray-300 shadow-lg -mx-4 px-4 py-4 mt-8">
                    <details className="group">
                        <summary className="flex items-center justify-between cursor-pointer list-none">
                            <h3 className="text-lg font-medium leading-6 text-gray-900">Evaluation Results Form</h3>
                            <span className="text-sm text-indigo-600 group-open:hidden">Click to expand</span>
                            <span className="text-sm text-indigo-600 hidden group-open:inline">Click to collapse</span>
                        </summary>
                        <div className="mt-4">
                            {scoringForm ?? (
                                <ResultsSubmissionForm
                                    submissionMeta={submissionMeta}
                                    onSubmitSuccess={onSubmitSuccess}
                                />
                            )}
                        </div>
                    </details>
                </div>
            )}
        </div>
    );
}
